import axios from 'axios'
import store from '@/store'
import { USER_TOKEN_REFRESH } from '@/store/modules/user/action-types'
import { codes } from '@/consts/apiErrors'
import { $ui, logout, toast } from '@/utils/ui'
import { ACCOUNT_INDEXED_RIGHTS } from '@/consts/rights'
import { getForbiddenMessage } from '@/utils/data/rights'

// eslint-disable-next-line no-undef
const network = axios.create({
  baseURL: process.env.API
})

network.interceptors.request.use((config) => {
  const t = store.getters['user/authToken']
  if (t) {
    config.headers.Authorization = `Bearer ${t.access_token}`
  }
  if (process.env.DEV && window.xdebug) {
    config.params = {
      ...config.params || {},
      XDEBUG_SESSION_START: 'PHPSTORM'
    }
  }
  return config
})

const regIsGranted = /@IsGranted\("can(\w+)"\)/gm
const handleApiError = (response) => {
  if (response && response.status === 503) {
    $ui.serverMaintenance = {
      maintenance: true,
      message: _.get(response, ['data', 'message'], 'Une maintenance est en cours...')
    }
  }
  const error = _.get(response, ['data', 'error'])
  if (error) {
    const message = codes[error.code] || codes[error] || error.message
    if (message) {
      const isGranted = regIsGranted.exec(message)
      const right = isGranted && ACCOUNT_INDEXED_RIGHTS[_.lowerFirst(isGranted[1])]
      if (right) {
        throw new Error(getForbiddenMessage(right))
      }
      if (error.code !== 0 || response.status >= 400) {
        throw new Error(message)
      }
    }
  }
}

network.interceptors.response
  .use(
    (response) => {
      handleApiError(response)
      return response
    },
    async (error) => {
      if (error.response &&
        error.response.status === 401 &&
        error.response.data &&
        error.response.data.error === 'invalid_grant') {
        try {
          await store.dispatch('user/' + USER_TOKEN_REFRESH)
          return network(error.config)
        } catch (e) {
          debouncedLogout()
        }
      }
      if (error.response) {
        handleApiError(error.response)
      }
      return Promise.reject(error)
    }
  )

const debouncedLogout = _.debounce(async () => {
  toast.negative('Veuillez vous réauthentifier')
  await logout(true)
}, 500)

export default network
